import { toFixedWithRound } from '@application/Utils/NumberUtils'
import { Option } from '@core/Constants/FieldOptionsConstants'
import { NUMBER_REGEXP, THREE_DECIMAL_NUMBER_REGEXP } from '@core/Constants/ValidationConstants'
import { MeasurementUnit } from '@core/Types/Measurement'

export const calculateCBM = ({
    quantity,
    length,
    width,
    height,
    unit,
}: {
    quantity: string
    length: string
    width: string
    height: string
    unit: MeasurementUnit
}): number => {
    const volumeConvertor = unit === 'in' ? 61023.842 : 1000000

    const volume = toFixedWithRound((+length * +width * +height) / volumeConvertor, 3)

    return toFixedWithRound(+quantity * volume, 3)
}

export const handleMeasurementUnitChange =
    ({ setMeasurementUnit }: { setMeasurementUnit: (value: MeasurementUnit) => void }) =>
    (option: Option<MeasurementUnit>): void => {
        setMeasurementUnit(option.value)
    }

export const handleQtyChange =
    (setQuantity: (value: string) => void) =>
    (e: React.ChangeEvent<HTMLInputElement>): void => {
        const value = e.target.value

        if (value && !NUMBER_REGEXP.test(value)) {
            return
        }

        setQuantity(e.target.value)
    }

export const handleMeasurementChange =
    (setValue: (value: string) => void) =>
    (e: React.ChangeEvent<HTMLInputElement>): void => {
        const value = e.target.value

        if (value && !THREE_DECIMAL_NUMBER_REGEXP.test(value)) {
            return
        }
        setValue(value)
    }
